import { Row, Col, Skeleton } from 'antd';
import { DashboardCard } from '../../../components/DashboardCard';
import { SECTION_GAP } from '../constants';

export function DashboardSkeleton() {
  return (
    <>
      <Row gutter={[20, 20]}>
        {Array.from({ length: 4 }).map((_, idx) => (
          <Col xs={24} sm={12} lg={6} key={idx}>
            <DashboardCard bodyStyle={{ padding: '18px 22px 20px' }}>
              <Skeleton active paragraph={{ rows: 1 }} title={{ width: '50%' }} />
            </DashboardCard>
          </Col>
        ))}
      </Row>

      <div style={{ marginTop: SECTION_GAP }}>
        <DashboardCard>
          <Skeleton.Node active style={{ width: '100%', height: 330 }}>
            <></>
          </Skeleton.Node>
        </DashboardCard>
      </div>

      <Row gutter={[SECTION_GAP, SECTION_GAP]} style={{ marginTop: SECTION_GAP }}>
        <Col xs={24} lg={16}>
          <DashboardCard>
            <Skeleton active paragraph={{ rows: 8 }} />
          </DashboardCard>
        </Col>
        <Col xs={24} lg={8}>
          <DashboardCard>
            <Skeleton active paragraph={{ rows: 6 }} />
          </DashboardCard>
        </Col>
      </Row>

      <div style={{ marginTop: SECTION_GAP }}>
        <Row gutter={[20, 20]}>
          {Array.from({ length: 4 }).map((_, idx) => (
            <Col xs={12} sm={12} lg={6} key={idx}>
              <DashboardCard bodyStyle={{ padding: '14px 18px 16px' }}>
                <Skeleton active paragraph={{ rows: 1 }} title={{ width: '55%' }} />
              </DashboardCard>
            </Col>
          ))}
        </Row>
      </div>
    </>
  );
}
